import React from "react";
import PropTypes from "prop-types";
import Modal from "shared/components/Modal";

import "./index.scss";

function SigninModal({
	className,
	children,

	show,
	onCancel,
}) {
	return (
		<Modal
			className={`signin-modal ${className}`}
			show={show}
			onCancel={onCancel}
			willCloseOnClick
		>
			<div className="signin-modal-content">
				{children}
			</div>
		</Modal>
	);
}

SigninModal.propTypes = {
	className: PropTypes.string,
	children: PropTypes.any,
	show: PropTypes.bool,
	onCancel: PropTypes.func,
};

SigninModal.defaultProps = {
	className: null,
	children: null,
	show: false,
	onCancel: undefined,
};

export default SigninModal;



// WEBPACK FOOTER //
// ./src/shared/components/SigninModal/index.jsx